import { createContext } from 'react';

const BrandsContext = createContext({
  brands: [],
  updateBrands: () => {},
  currentBrand: null,
  setCurrentBrand: () => {},
});
export default BrandsContext;
